import React from 'react';

const FAQ = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="section-header">
          <h1 className="page-title">FAQ</h1>
          <p className="section-description">
            Questions fréquemment posées sur nos services.
          </p>
        </div>
        <div className="text-center" style={{padding: 'var(--spacing-xl) 0'}}>
          <p className="page-text">Contenu à venir...</p>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
